'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scales = require('./scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  neutral: {
    lightest: _scales2.default.neutral.N1,
    light: _scales2.default.neutral.N4,
    base: _scales2.default.neutral.N9,
    dark: _scales2.default.neutral.N10
  },

  blue: {
    lightest: _scales2.default.primary.P1,
    light: _scales2.default.primary.P4,
    base: _scales2.default.primary.P9,
    dark: _scales2.default.primary.P10
  },

  red: {
    lightest: '#fef6f6',
    light: '#fae2e2',
    base: '#ec4c47',
    dark: '#bf0e08'
  },

  orange: {
    lightest: '#fdf8f3',
    light: '#fae3cd',
    base: '#d9822b',
    dark: '#95591e'
  },

  yellow: {
    lightest: '#fef8e7',
    light: '#fbe6a2',
    base: '#f7d154',
    dark: '#7e6514'
  },

  green: {
    lightest: '#f1faf5',
    light: '#d4eee2',
    base: '#47b881',
    dark: '#00783e'
  },

  teal: {
    lightest: '#f1fbfc',
    light: '#d2eef3',
    base: '#14b5d0',
    dark: '#007489'
  },

  purple: {
    lightest: '#f8f7fc',
    light: '#eae7f8',
    base: '#735dd0',
    dark: '#37248f'
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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